<template>
  <div class="cart-order-fast">
    <div class="cart-order-fast__inner" v-if="!isSuccess">
      <div class="cart-order-fast__title texts texts_heading-18-15">
        Покупка в 1 клик
      </div>

      <div class="cart-order-fast__checkout">
        <TheCartAddedProductCard :product="addedProduct" v-if="addedProducts" v-for="addedProduct in addedProducts"/>
      </div>

      <div class="cart-order-fast__subtitle texts texts_body">
        Отправьте данные для заказа, в течение 15 минут вам позвонит менеджер для его подтверждения
      </div>

      <ul class="cart-order-fast__fields form-field">
        <li class="cart-order-fast__field field">
          <label for="fast_order_name" class="cart-order-fast__label">
            Ваше имя
          </label>

          <input type="text" id="fast_order_name" class="cart-order-fast__input field__input" v-model="name" placeholder="Имя">

          <ItemErrors :errors="errors.name"/>
        </li>

        <li class="cart-order-fast__field field">
          <label for="fast_order_phone" class="cart-order-fast__label">
            Номер телефона
          </label>

          <input
              type="text"
              v-model="phone"
              id="fast_order_phone"
              name="phone"
              required="required"
              class="cart-contacts__input required field__input"
              ref="phone"
              placeholder="+7"
          >

          <ItemErrors :errors="errors.phone"/>
        </li>
      </ul>

      <div class="cart-order-fast__button-wrap">
        <div class="cart-order-fast__policy policy">
          <input type="checkbox" value="1" checked="checked" id="fast_order_check" class="policy__input" required>

          <label for="fast_order_check" class="policy__label texts texts_text-12">
            Ставя отметку, я даю свое согласие на обработку моих персональных данных и принимаю условия
            <a href="#"
               target="_blank"
               title="Политика конфиденциальности"
               class="policy__link"
            >
              политики конфиденциальности
            </a>
          </label>
        </div>

        <button class="cart-order-fast__button button button__ellipse button_yellow texts texts_button"
                @click="sendOrder"
                ref="submit"
        >
          Отправить
        </button>
      </div>
    </div>

    <div class="cart-order-fast__success" v-if="isSuccess">
      <TheFastOrderSuccess/>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ItemErrors from "./ItemErrors.vue";
import {makeMask} from "../../../js/field/phone";
import TheCartAddedProductCard from "./TheCartAddedProductCard.vue";
import TheFastOrderSuccess from "./TheFastOrderSuccess.vue";

export default {
  name: "TheCartOrderFast",
  data() {
    return {
      isSuccess: false,
    }
  },
  components: {
    TheCartAddedProductCard,
    ItemErrors,
    TheFastOrderSuccess,
  },
  props: {
    buyableId: null,
    cartClass: '',
  },
  mounted() {
    const phoneInput = this.$refs.phone;
    makeMask(phoneInput);
  },
  computed: {
    ...mapState('order', {
      'name': 'name',
      'phone': 'phone',
      'errors': 'errors'
    }),
    ...mapState('cart', {
      'checkout': 'checkout',
    }),
    addedProducts() {
      const products = this.checkout.items;
      return products ? products : null;
    },
    name: {
      get () {
        return this.$store.state.order.name
      },
      set (value) {
        this.$store.commit('order/setName', value)
      }
    },
    phone: {
      get () {
        return this.$store.state.order.phone
      },
      set (value) {
        this.$store.commit('order/setPhone', value)
      }
    },
  },
  methods: {
    ...mapActions('order', {
      'send': 'send'
    }),
    sendOrder() {
      if (!this.name || !this.phone) {
        this.send(true);
      } else {
        this.$refs.submit.disabled = true;
        this.send(true);
        this.isSuccess = !this.isSuccess;
      }
    }
  }
}
</script>

<style lang="scss">

</style>